<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">
            <a href="#" @click.prevent="$router.go(-1)"><i class="fa fa-angle-left"></i></a>
            {{ $route.params.market }}
          </h1>
        </b-col>
        <b-col>
          <span class="float-right">
            <b-button size="sm" class="ml-1">boton 1</b-button>
            <b-button size="sm" class="ml-1">boton 2</b-button>
          </span>
        </b-col>
      </b-row>
      <div>
        <b-table
          sticky-header="800px"
          :no-border-collapse="noCollapse"
          small
          hover
          responsive
          :items="items"
          :fields="fields"
        >
          <!-- We are using utility class `text-nowrap` to help illustrate horizontal scrolling -->
          <template #head()="scope">
            <div
              class="text-nowrap"
              v-if="scope.column != 'week' && scope.column != 'total' && scope.column != 'totalKg'"
            >
              {{ scope.label }}
            </div>
          </template>
          <template #cell()="scope">
            <div
              class="text-nowrap"
              v-if="scope.field.key != 'week' && scope.field.key != 'total' && scope.field.key != 'totalKg'"
              @click.prevent="$bvModal.show(scope.item.week + '-' + scope.field.key)"
            >
              <div v-if="parseFloat(scope.item[scope.field.key].total) > 0">
                {{ scope.item[scope.field.key].current | formatNumber }} /
                {{ scope.item[scope.field.key].total | formatNumber }}
                <b-badge variant="light">{{ scope.item[scope.field.key].percentage }}%</b-badge>
              </div>
              <div v-else>0</div>
            </div>

            <div v-else>
              {{ scope.item[scope.field.key] | formatNumber }}
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import mountMarketPlan from "./mountMarketPlan";

export default {
  name: "Plan",
  data() {
    return {
      stickyHeader: false,
      noCollapse: false,
      fields: [],
      items: []
    };
  },
  methods: {
    // Get plan data
    async getMarketPlan() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/api/comex/plan/?no_page&market=" + this.$route.params.id);
        return response.data;
      } catch (error) {
        console.log(error);
        return [];
      }
    }
  },
  mounted() {
    this.loading = true;
    this.getMarketPlan().then(async (data) => {
      this.loading = false;
      // Lodash group by subplan
      const grouped = await mountMarketPlan(data);
      this.items = grouped.items;
      this.fields = grouped.fields;
    });
  }
};
</script>

<style scoped>
>>> .clicableCell {
  cursor: pointer;
}
>>> .clicableCell:hover {
  background-color: #c6ccd0 !important;
}
/* inner shadow */
/* box-shadow: 0 0 0px 0px rgb(160 160 160 / 10%), inset 0 0 2px 2px rgb(130 130 130 / 10%); */
</style>
